import React, { Component, Fragment } from "react";
import parse from "html-react-parser";
import "./Bubble.css";
import moment from "moment";
export default class Avtar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            nudgeavtar: false,
            botPosition: "right"
        };
        this.bubble_clicked = this.bubble_clicked.bind(this);
        this.nudge_clicked = this.nudge_clicked.bind(this);        
        this.nudgeavtar_clicked = this.nudgeavtar_clicked.bind(this);
        // Listen to messages
        window.addEventListener(
            "message",
            this.windowBuddbleMessage.bind(this),
            false
        );
    }

    windowBuddbleMessage(event) {
        if (
            typeof event.data === "string" &&
            event.data.startsWith("msgXnudgepopup:")
        ) {
            this.setState({ nudgeavtar: true });
        }
    }

    nudgeavtar_clicked() {
        this.setState({ nudgeavtar: false });
        this.postMessage(`msgXnudgeminimized`);
    }

    bubble_clicked() {
        this.props.onOpened();
    }

    nudge_clicked() {
        this.props.onOpened();
    }


    handleMouseEnter = () => {
        this.setState({ hover: true });
    };
    handleMouseLeave = () => {
        this.setState({ hover: false });
    };
    /**
     * Posts a message to the parent window, if this window has one
     * @param {*} msg
     */
    postMessage(msg) {
        if (window.parent) {
            window.parent.postMessage(msg, "*");
        }
    }
    componentDidMount() {
        console.log(moment().format('YYYY-MM-DD hh:mm:ss'),'Bubble is going to Load');
        const botSettings = this.props.botSettings;
        if (botSettings !== undefined &&
            botSettings.bubbleSettings !== undefined &&
            botSettings.bubbleSettings !== null) {
            if (
                botSettings.bubbleSettings.bubblePosition !== undefined &&
                botSettings.bubbleSettings.bubblePosition !== null
            ) {
                const bubblePosition = botSettings.bubbleSettings.bubblePosition;                
                if (this.props.mobile === "true") {
                    this.setState({ botPosition: bubblePosition.alignInMobile === "Left" ? this.props.position + "_" + bubblePosition.alignInMobile.toLowerCase() : this.props.position });
                    this.postMessage(
                        `msgXalign:${bubblePosition.alignInMobile}|side:${bubblePosition.sideInMobile}|bottom:${bubblePosition.bottomInMobile}`
                    );
                } else {
                    this.setState({ botPosition: bubblePosition.align === "Left" ? this.props.position + "_" + bubblePosition.align.toLowerCase() : this.props.position });
                    this.postMessage(
                        `msgXalign:${bubblePosition.align}|side:${bubblePosition.side}|bottom:${bubblePosition.bottom}`
                    );
                }
            }
            //Post Message to set the animation settings iframe
      if (
        botSettings.bubbleSettings.scrollAnimation !== undefined &&
        botSettings.bubbleSettings.scrollAnimation !== null
      ) {
        const scrollAnimation = botSettings.bubbleSettings.scrollAnimation;
        if (scrollAnimation.enabled === true) {
          this.postMessage(
            `msgXscrollanimation|${scrollAnimation.beforeAnimationTop}|${scrollAnimation.afterAnimationTop}`
          );
        }
      }
        }
        else {
            this.postMessage(`msgXremoveposition`);
          }
    }
    render() {        
        return !this.props.disabledChatbot ? (
            this.state.nudgeavtar === false ? (
                <div className={this.state.botPosition}
                    onClick={this.bubble_clicked}
                >
                    {this.props.currentNudge !== undefined && this.props.currentNudge.length > 0
                        && this.props.currentNudge.forEach((nudge) =>
                            nudge.eyeCatcher && nudge.eyeCatcher.messages &&
                            nudge.eyeCatcher.messages.map((msg) => {
                                return typeof msg === "string" ? (
                                    <div className="chat_hint"
                                        onClick={this.nudge_clicked}
                                    >
                                        {msg}
                                        <div
                                            className="chat_hint_close"                                            
                                        ></div>
                                    </div>
                                ) : (
                                    <div className="chat_hint_image_container">
                                        <img className="chat_hint_image" alt="" src={msg.url} />
                                    </div>
                                );
                            })
                        )}
                    {this.props.botSettings !== undefined ? (
                        this.props.botSettings.bubbleSettings !== undefined &&
                            this.props.botSettings.bubbleSettings !== null &&
                            this.props.botSettings.bubbleSettings.enabled ? (
                            <Fragment>
                                <div
                                    className={
                                        this.props.fadeIn
                                            ? `chat_bubble chat_bubble_fade ${this.props.mobile == "true"
                                                ? "askmebtnmobile"
                                                : "askmebtn"
                                            }`
                                            : `chat_bubble chat_bubble_shrink ${this.props.mobile == "true"
                                                ? "askmebtnmobile"
                                                : "askmebtn"
                                            }`
                                    }
                                    style={{
                                        backgroundColor:
                                            this.props.botSettings.bubbleSettings.backGroundColor,
                                        color: this.props.botSettings.bubbleSettings.textColor,
                                        paddingTop:
                                            this.props.botSettings.bubbleSettings.paddingTop,
                                        ...(this.state.hover && {
                                            backgroundColor:
                                                this.props.botSettings.bubbleSettings
                                                    .backGroundColorHover,
                                            color:
                                                this.props.botSettings.bubbleSettings.textColorHover,
                                        }),
                                    }}
                                    onMouseEnter={this.handleMouseEnter} // Or onMouseOver
                                    onMouseLeave={this.handleMouseLeave}
                                >
                                    {parse(this.props.botSettings.bubbleSettings.text)}
                                </div>
                            </Fragment>
                        ) : (
                            <div
                                style={{
                                    backgroundImage: `url(${this.props.botSettings.urls.icon}`,
                                }}
                                className={
                                    this.props.fadeIn
                                        ? "chat_bubble chat_bubble_fade"
                                        : "chat_bubble chat_bubble_shrink"
                                }
                            ></div>
                        )
                    ) : (
                        <div className="chat_loading"> </div>
                    )}
                </div>
            ) : (
                <div className={this.state.botPosition}
                    onClick={this.nudgeavtar_clicked}
                >
                    <div
                        style={{
                            backgroundImage: `url(${this.props.botSettings.urls.icon}`,
                        }}
                        className={
                            this.props.fadeIn
                                ? "chat_bubble chat_bubble_fade"
                                : "chat_bubble chat_bubble_shrink"
                        }
                    ></div>
                </div>
            )
        ) : null;
    }
}